// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 824 ? "906a09f8" : chunkId) + "." + {"42":"5c91b8f9943d0d46","55":"4cb649bba0cf70a7","170":"2f2109b571d5e44d","746":"cac61743db87112c","824":"b7cc8e983453374a","836":"db40f9ca7cea11ea","878":"37d24754a8684f76","973":"829db0a14713e5ca"}[chunkId] + ".js";
};